import { Toaster } from '@ixigo/iui/Toast';
import { createFileRoute } from '@tanstack/react-router';
import {
	FaqSection,
	fetchFaq,
	fetchOffers,
	fetchWhyBook,
	OffersSection,
	SearchSection,
	UpcomingTrips,
	WhyBookSection,
} from './-home';

export const Route = createFileRoute('/')({
	head: () => ({
		meta: [{ name: 'robots', content: 'index, follow' }],
	}),
	component: Home,
	loader: async () => {
		try {
			const [offers, whyBookData, faqData] = await Promise.all([
				fetchOffers(),
				fetchWhyBook(),
				fetchFaq(),
			]);
			return {
				offers: offers?.data?.homepage || null,
				whyBookData: whyBookData?.data || null,
				faqData: faqData || null,
			};
		} catch {
			return {
				offers: null,
				whyBookData: null,
				faqData: null,
			};
		}
	},

	// changing query params or chaging history with hash or only state triggers a reload
	// use loaderDeps if query params changes based data fetching is required
	// or use shouldReload to gain fine grained control over when to reload
	// setting staleTime to Infinity to avoid unnecessary reloads as this page is static mostly
	staleTime: Infinity,
	ssr: true,
});

/**
 * Home page component for cab booking
 * Features the main booking form, benefits section, and offers
 */
function Home() {
	const {
		offers,
		whyBookData: whyBookItemList,
		faqData,
	} = Route.useLoaderData();
	return (
		<div className="min-h-screen bg-tertiary flex flex-col gap-y-10">
			<SearchSection />
			<UpcomingTrips />
			<div className="flex flex-col gap-y-10">
				{whyBookItemList && whyBookItemList.length > 0 && (
					<WhyBookSection itemList={whyBookItemList} />
				)}
				{offers && offers.length > 0 && <OffersSection offers={offers} />}
				{faqData && <FaqSection faqData={faqData} />}
			</div>
			<Toaster />
		</div>
	);
}
